import React from "react";
import { ListGroup, Modal } from "react-bootstrap";
import { FeatureList } from "./api/Mapbox";
import { PiMapPin, PiMapPinAreaFill } from "react-icons/pi";

export interface LocationInfoModalProps {
    features?: FeatureList;
    onClose:   () => void;
    title?:    string;
}

export const LocationInfoModal: React.FC<LocationInfoModalProps> = ( {
    features,
    onClose,
    title = "Location Info"
} ) => {
    return <Modal show={!!features} onHide={onClose} centered>
        <Modal.Header closeButton className="border-0 mb-0 bg-body-secondary">
            <Modal.Title className="w-100 text-center">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-0 p-0 bg-light">
            <ListGroup className="shadow p-0 m-0" variant="flush">
                {features?.features.map( ( f, idx ) => (
                    <ListGroup.Item key={idx} className="d-flex gap-3">
                        <div className="d-flex align-items-center">
                            <PiMapPin className="fs-4 text-secondary" />
                        </div>
                        <div>
                            <div>{f.properties.name}</div>
                            <small className="text-muted small">{f.properties.address}</small>
                        </div>
                    </ListGroup.Item>
                ) )}
            </ListGroup>
        </Modal.Body>
    </Modal>;
};
